document.addEventListener('DOMContentLoaded', function() {
  const body = document.body;
  const header = document.querySelector('.header-wrapper');
  const mobileMenuButton = document.querySelector('.header__icon--menu');

  if (!header) return;

  let scrollTicking = false;
  let menuOpen = false;

  function updateHeaderState() {
    if (menuOpen) {
      body.classList.add('menu-open-no-shrink');
      body.classList.remove('scrolled-past-header');
    } else {
      body.classList.remove('menu-open-no-shrink');
      body.classList.toggle('scrolled-past-header', window.scrollY > 50);
    }
  }

  function syncMenuOpen() {
    menuOpen = body.classList.contains('overflow-hidden') ||
               header.querySelectorAll('details[open]').length > 0;
    updateHeaderState();
  }

  const observer = new MutationObserver(syncMenuOpen);
  header.querySelectorAll('details').forEach(function(details) {
    observer.observe(details, { attributes: true, attributeFilter: ['open'] });
  });

  if (mobileMenuButton) {
    mobileMenuButton.addEventListener('click', function() {
      setTimeout(syncMenuOpen, 30);
    });
  }

  window.addEventListener('scroll', function() {
    if (!scrollTicking) {
      requestAnimationFrame(function() {
        updateHeaderState();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  updateHeaderState();
});
